import axios from 'axios'
import { API_BASE } from '@/api'

/** Appels sans connexion (patient qui revient de la page de paiement). */
export const apiPublique = axios.create({ baseURL: `${API_BASE}/api/public`, timeout: 30000 })

export const suiviPaiementPublic = {
  data() {
    return { tx: null, erreur: '', minuteur: null, reference: this.$route.query.ref }
  },
  created() {
    if (!this.reference) {
      this.erreur = 'Lien de paiement incomplet.'
      return
    }
    this.charger()
    this.minuteur = setInterval(() => {
      if (this.tx && ['ACCEPTEE', 'REFUSEE', 'EXPIREE'].includes(this.tx.statut) && this.tx.enregistre !== false) {
        clearInterval(this.minuteur)
        return
      }
      this.charger()
    }, 5000)
  },
  beforeUnmount() {
    clearInterval(this.minuteur)
  },
  methods: {
    async charger() {
      try {
        this.tx = (await apiPublique.get(`/paiements-en-ligne/${this.reference}`)).data
      } catch (e) {
        this.erreur = e.response?.data?.message || 'Paiement introuvable.'
        clearInterval(this.minuteur)
      }
    },
    fcfa(v) {
      return new Intl.NumberFormat('fr-FR').format(v || 0) + ' FCFA'
    }
  }
}
